var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13937_52049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0765 2.30913C13.2786 2.10709 13.5184 1.94683 13.7824 1.83749C14.0464 1.72815 14.3293 1.67188 14.615 1.67188C14.9007 1.67187 15.1836 1.72815 15.4476 1.83749C15.7116 1.94683 15.9514 2.10709 16.1535 2.30913C16.3555 2.51116 16.5158 2.75101 16.6251 3.01498C16.7344 3.27895 16.7907 3.56187 16.7907 3.84759C16.7907 4.13331 16.7344 4.41623 16.6251 4.6802C16.5158 4.94417 16.3555 5.18402 16.1535 5.38605L5.76886 15.7707L1.53809 16.9245L2.69193 12.6937L13.0765 2.30913Z",
    stroke: "#1B192F",
    strokeWidth: 1.29231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13937_52049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4615,
    height: 18.4615,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.0c1f8761e2452236fb5ad7f89ac9833f.svg";
export { ForwardRef as ReactComponent };